import React, { useState, useEffect, useRef, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Menu, MenuItem, Typography, ThemeProvider } from '@mui/material';
import DVTable from '../DVTable';
import { colors } from '../../theme/color-palette';
import { makeStyles } from '@material-ui/core/styles';
import { CustomMenuItem } from '../CustomMenuItem';
import { InlineLabelSelect } from '../InlineLabelSelect';
import { InlineLabelSelectFormControl } from '../InlineLabelSelectFormControl/index.js';
import downloadIcon from '../../assets/SVGs/download-icon.svg';
import {
	TabNavigation,
	TabNavigationItem,
	Badge,
	Alert,
} from '@walmart-dataventures/shared-components';
import {
	getAnomalyDetectionData,
	getAnomaliesSalesMetrics,
	updateTableRowsAndColumns,
	resetADTableRows,
} from '../../redux/actions/anomalyDetectionActions';
import AnomalyOverview from './AnomalyOverview/index.js';
import { theme } from '../../theme/theme';
import {
	ALERT_MESSAGE,
	ALERT_BUTTON,
	ALL,
	OUTPERFORMING,
	UNDERPERFORMING,
	SUB_CATEGORY,
	CATEGORY,
	DEPARTMENT,
	INVENTORY,
	PRICING_CHANGE,
	POINTS_OF_DISTRIBUTION,
	ASSORTMENT_CONFIGURATION,
	NOT_IDENTIFIED,
	DOWNLOAD_EXCEL,
	BOGLE_REGULAR,
	INVALID_HIERARCHY,
	PARTIAL_HIERARCHY,
	GUIDED_INSIGHTS_HOME,
} from '../../constants/constant.js';
import { disabledsADAlert } from '../../redux/actions/appGuideActions';
import { UserPortalContext } from '../../context/appcontext';
import ShimmerLoading from './ShimmerGuidedInsights';
import { saveWeekFilter } from '../../redux/actions/salesActions.js';
import MultiItemDropDown from '../MultiItemDropDown/MultiItemDropDown.jsx';
import ErrorScreen from './ErrorScreen';
import DownloadIcon from '../../assets/SVGs/download-icon.svg';
import { getValueForExcel } from '../Table/utils';
import IconButton from '@mui/material/IconButton';
import BusinessHierarchy from '../Filter/BusinessHierarchy';
import { saveEventTrack } from '../../redux/actions/eventTrackAction';
import TextWithDefinition from '../TextWithDefinition/index.js';
import WarningIcon from '../../assets/icons/warning.svg';
import CloseIcon from '../../assets/icons/close.svg';
import SupplierShareChart from './SupplierShareChart/index.js';
import analytics from '../../helper/analytics';
import LeadingCheck from '../../assets/SVGs/LeadingCheck.svg';
import { HIERARCY_LEVEL } from './constants.js';

const useStyles = makeStyles(() => ({
	container: {
		border: '1px solid #dadce0',
		borderRadius: '8px',
		height: '422px',
		margin: '12px',
	},
	flexibleContainer: {
		border: '1px solid #dadce0',
		borderRadius: '8px',
		margin: '12px',
	},
	snackbar: {
		border: '1px solid #dadce0',
		borderRadius: '8px',
		height: '20px',
		margin: '12px',
		width: '98.5%',
	},
	table_drawerMenu: {
		position: 'absolute',
		width: '260px',
		padding: '4px 0px',
		flexDirection: 'column',
		alignItems: 'flex-start',
		marginLeft: '30px',
		borderRadius: '4px',
	},
	showAlert: {
		marginLeft: '13px',
		marginRight: '13px',
		marginTop: '6px',
		marginBottom: '4px',
	},
	anomalyDetails: {
		fontSize: '18px !important',
		fontWeight: '400 !important',
		lineHeight: '16px !important',
		color: `${colors.FONT_COLOR} !important`,
		fontFamily: `${BOGLE_REGULAR} !important`,
		margin: '22px !important',
		cursor: 'pointer',
	},
	button_ellipsis: {
		padding: 0,
	},
	downloadContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '16px',
	},
}));

const PoweredAI = () => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [showWarning, setShowWarning] = useState(true);
	const dispatch = useDispatch();
	const navigate = useHistory();
	const gridRef = useRef();
	const rcaDropdownSelect = useRef();

	const rootCauseOptions = [
		{
			shortLabel: 'All',
			title: 'All',
			value: ALL,
			id: 'rh-all',
		},
		{
			shortLabel: 'Replenishment Health',
			title: 'Replenishment Health',
			value: INVENTORY,
			id: 'rc-ih',
		},
		{
			shortLabel: 'Pricing Change',
			title: 'Pricing Change',
			value: PRICING_CHANGE,
			id: 'rc-pc',
		},
		{
			shortLabel: 'Points of Distribution',
			title: 'Points of Distribution',
			value: POINTS_OF_DISTRIBUTION,
			id: 'rc-pod',
		},
		{
			shortLabel: 'Assortment Configuration',
			title: 'Assortment Configuration',
			value: ASSORTMENT_CONFIGURATION,
			id: 'rc-ac',
		},
		{
			shortLabel: 'Not Identified',
			title: 'Not Identified',
			value: NOT_IDENTIFIED,
			id: 'rc-ni',
		},
	];

	const [anomalyType, setAnomalyType] = useState();
	const [tabStates, setTabStates] = useState([true, false, false]);
	const [rcaValue, setRcaValue] = useState(rootCauseOptions);
	const portalUserContext = useContext(UserPortalContext);

	const isGuidedAlertDismissed = JSON.parse(
		sessionStorage.getItem('isGuidedAlertDismissed')
	);

	let selectedFilters = useSelector(
		(state) => state?.salesReducer?.selectedFilters
	);

	const selectedHierarchy = useSelector(
		(state) => state?.fullCompanyViewReducer?.selectedHierarchy
	);

	const rhIdsList = selectedHierarchy?.hierarchyFilterRhId?.split(',');

	const weekFilters = JSON.parse(sessionStorage.getItem('weekfilters'));

	if (!selectedFilters?.startDate) {
		selectedFilters = weekFilters;
	}

	const { weekFilter, startDate, endDate } = selectedFilters;

	const [externalFilters, setExternalFilters] = useState({});

	const [showAlert, setShowAlert] = useState(
		isGuidedAlertDismissed ? false : true
	);

	const handleAnomalyChange = (event) => {
		const newValue = event?.target?.value;
		setAnomalyType(newValue);

		const request = {
			event: 'Anomaly Type Selection',
			event_description: `Anomalies Filter Selection: ${newValue}`,
			attributes: GUIDED_INSIGHTS_HOME,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));

		if (newValue === OUTPERFORMING) {
			setExternalFilters({
				...externalFilters,
				marketShareChng: {
					type: 'greaterThan',
					filter: 0,
				},
			});
		} else if (newValue === UNDERPERFORMING) {
			setExternalFilters({
				...externalFilters,
				marketShareChng: {
					type: 'lessThan',
					filter: 0,
				},
			});
		} else {
			setExternalFilters({
				...externalFilters,
				marketShareChng: {},
			});
		}
	};

	const flattenRcaOptionsToArray = (value) => {
		const rcaValueArray = [];
		for (let i = 0; i < value.length; i++) {
			rcaValueArray.push(value[i].value);
		}
		return rcaValueArray;
	};

	const handleRootCauseChange = () => {
		const flatArray = flattenRcaOptionsToArray(rcaValue);

		setExternalFilters({
			...externalFilters,
			rcaTags: {
				values: flatArray,
			},
		});
	};

	const openMenu = async (event) => {
		setAnchorEl(event.currentTarget);
	};

	const closeMenu = () => {
		setAnchorEl(null);
	};

	const {
		tableRows,
		tableColumns,
		departmentPositiveItems,
		departmentNegativeItems,
		categoryPositiveItems,
		categoryNegativeItems,
		subcategoryPositiveItems,
		subcategoryNegativeItems,
		departmentTableRows,
		categoryTableRows,
		subcategoryTableRows,
		isLoading,
		deptAnomalies,
		catAnomalies,
		subCatAnomalies,
		isError,
	} = useSelector((state) => state.anomalyDetectionReducer);

	const anomaly_summary = useSelector(
		(state) => state?.anomalyDetectionReducer
	);

	// Initial page fetching from GraphQL API
	useEffect(() => {
		if (selectedHierarchy?.hierarchyFilterRhId != '') {
			dispatch(
				getAnomalyDetectionData({
					payload: {
						startDate: startDate,
						endDate: endDate,
						hierarchyArr: rhIdsList,
					},
				})
			);
		}
		dispatch(
			saveWeekFilter({
				...selectedFilters,
				selectedFilter: 'Store',
			})
		);
	}, []);

	// Listen to any change on the global filters, to refetch the anomaly details from GraphQL
	useEffect(() => {
		if (selectedHierarchy?.hierarchyFilterRhId != '') {
			dispatch(
				getAnomalyDetectionData({
					payload: {
						startDate: startDate,
						endDate: endDate,
						hierarchyArr: rhIdsList,
					},
				})
			);
		}

		// Set back the selected tab to Department
		setTabStates([true, false, false]);
		// Reset filters
		setRcaValue(rootCauseOptions);
		setAnomalyType(ALL);
	}, [weekFilter, startDate, endDate, selectedHierarchy]);

	useEffect(() => {
		handleRootCauseChange();
	}, [rcaValue]);

	const onGridReady = () => {
		// Apply AG-Grid API Changes here //
		sortDefault();
	};

	// Sort AG-Grid Rows by "supplier_share_change"
	const sortDefault = () => {
		gridRef.current?.columnApi?.applyColumnState({
			state: [{ colId: 'marketShareChng', sort: 'asc' }],
			defaultState: { sort: null },
		});
	};

	const handleTabNavigation = (event, item) => {
		event.preventDefault();
		const request = {
			event: 'Anomaly Product Hierarchy Selection',
			event_description: `Anomalies and Root Causes Table Selection: ${item}`,
			attributes: GUIDED_INSIGHTS_HOME,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));

		const payload = {
			startDate: startDate,
			endDate: endDate,
		};

		if (item === DEPARTMENT) {
			setTabStates([true, false, false]);
			if (deptAnomalies.length > 0) {
				if (departmentTableRows.length > 0) {
					dispatch(updateTableRowsAndColumns(HIERARCY_LEVEL.DEPARTMENT));
				} else {
					dispatch(
						getAnomaliesSalesMetrics({
							attribute: HIERARCY_LEVEL.DEPARTMENT,
							anomalies: deptAnomalies,
							request: payload,
						})
					);
				}
			} else {
				dispatch(resetADTableRows());
			}
		} else if (item === CATEGORY) {
			setTabStates([false, true, false]);
			if (catAnomalies.length > 0) {
				if (categoryTableRows.length > 0) {
					dispatch(updateTableRowsAndColumns(HIERARCY_LEVEL.CATEGORY));
				} else {
					dispatch(
						getAnomaliesSalesMetrics({
							attribute: HIERARCY_LEVEL.CATEGORY,
							anomalies: catAnomalies,
							request: payload,
						})
					);
				}
			} else {
				dispatch(resetADTableRows());
			}
		} else {
			setTabStates([false, false, true]);
			if (subCatAnomalies.length > 0) {
				if (subcategoryTableRows.length > 0) {
					dispatch(updateTableRowsAndColumns(HIERARCY_LEVEL.SUBCATEGORY));
				} else {
					dispatch(
						getAnomaliesSalesMetrics({
							attribute: HIERARCY_LEVEL.SUBCATEGORY,
							anomalies: subCatAnomalies,
							request: payload,
						})
					);
				}
			} else {
				dispatch(resetADTableRows());
			}
		}

		// Reset filters
		setRcaValue(rootCauseOptions);
		rcaDropdownSelect.current.setToDefaultState();
	};

	const classes = useStyles();
	// const navigate = useHistory();

	const handleTableCellClicked = (data) => {
		const anomalyChange =
			data?.net_sales_change > 0 || data?.supplier_share_change > 0 ? 1 : -1;
		const identified = data?.rcaTags?.includes('notidentified')
			? 'notidentified'
			: 'identified';

		const request = {
			event: 'Root Cause Page Launched',
			event_description: 'AI Insights Tab',
			attributes: GUIDED_INSIGHTS_HOME,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));

		//Adobe event : Track the page
		analytics.trackPageInfo('Root Cause Page');

		navigate.push({
			pathname: `/details/root-cause-analysis/${String(
				data?.type
			).toLocaleLowerCase()}/${data?.id}/${
				data?.name
			}/${identified}/anomalyChange/${anomalyChange}`,
		});
	};

	const closeAlertDialogue = () => {
		setShowAlert(false);
		sessionStorage.setItem('isGuidedAlertDismissed', true);
	};

	const handlebuttonClick = () => {
		dispatch(
			disabledsADAlert({ portalUserContext: portalUserContext, value: true })
		);
		setShowAlert(false);
	};

	const { dsADAlertDisabled } = useSelector((state) => state.appGuideReducer);

	const chartData = useSelector(
		(state) => state?.anomalyDetectionReducer?.supplierShare
	);

	const anomalyOptions = [
		{ label: 'All', value: ALL, id: 'at-all' },
		{ label: 'Outperforming', value: OUTPERFORMING, id: 'at-out' },
		{ label: 'Underperforming', value: UNDERPERFORMING, id: 'at-under' },
	];

	const handleDownload = () => {
		const downloadTime = new Date().toLocaleString()?.replace(',', ' ');
		gridRef.current?.api?.exportDataAsExcel({
			fileName: `Walmart Scintilla-Channel Performance-${downloadTime}`,
			sheetName: 'Data',
			shouldRowBeSkipped(params) {
				return params.node.data?.fullWidth;
			},
			processCellCallback(params) {
				return params.column.colDef.colId === 'ag-Grid-AutoColumn'
					? params?.node?.data?.description
					: getValueForExcel(params);
			},
		});

		const request = {
			event: 'Download',
			event_description: 'Anomaly Detail .Xlsx report',
			attributes: GUIDED_INSIGHTS_HOME,
		};
		dispatch(saveEventTrack({ request, portalUserContext }));
	};

	const CustomWarningIcon = () => (
		<img src={WarningIcon} alt="Warning Message" />
	);

	const CustomCloseIcon = () => <img src={CloseIcon} alt="Close" />;

	const alertMessage = {
		1: PARTIAL_HIERARCHY,
		2: INVALID_HIERARCHY,
	};

	const parseData = (data = []) => {
		if (data?.length > 0) {
			const parseData = data?.map((item) => {
				const temp = {
					id: parseInt(item.node.id),
					name: item.node.name,
					netSalesTY: Number(parseFloat(item.node.netSalesTY)?.toFixed(2)),
					netSalesTYChngRef: Number(
						parseFloat(item.node.netSalesTYChngRef)?.toFixed(2)
					),
					netSalesTYChngPctRef: Number(
						parseFloat(item.node.netSalesTYChngPctRef)?.toFixed(2)
					),
					marketShare: Number(parseFloat(item.node.marketShare)?.toFixed(2)),
					marketShareChng: Number(
						parseFloat(item.node.marketShareChng)?.toFixed(2)
					),
					unitsTY: Number(parseFloat(item.node.unitsTY)?.toFixed(2)),
					unitsTYChngPctRef: Number(
						parseFloat(item.node.unitsTYChngPctRef)?.toFixed(2)
					),
					unitsTYChngRef: Number(
						parseFloat(item.node.unitsTYChngRef)?.toFixed(2)
					),
					rcaTags: item.node.rcaTags.map((tag) => tag.toLowerCase()),
					type: item.node.attribute.toLocaleLowerCase(),
				};
				return temp;
			});
			return parseData;
		}
		return data;
	};

	return (
		<ThemeProvider theme={theme}>
			{isLoading ? (
				<ShimmerLoading />
			) : (
				<Grid container>
					<Grid item xs={12} sm={12} md={12} lg={12} sx={{ mr: 1.5 }}>
						{[1, 2].includes(chartData?.hierarchy_validation) && showWarning ? (
							<Box
								sx={{
									marginRight: '13px',
									marginLeft: '14px',
								}}>
								<Alert
									components={{
										AlertWarningIcon: CustomWarningIcon,
										AlertCloseIcon: CustomCloseIcon,
									}}
									variant="warning"
									onClose={() => setShowWarning(false)}>
									{alertMessage[chartData?.hierarchy_validation]}
								</Alert>
							</Box>
						) : null}
						{showAlert && !dsADAlertDisabled && (
							<Box className={classes.showAlert}>
								<Alert
									actionButtonProps={{
										children: ALERT_BUTTON,
										onClick: handlebuttonClick,
									}}
									closeButton
									onClose={closeAlertDialogue}>
									{ALERT_MESSAGE}
								</Alert>
							</Box>
						)}
					</Grid>
					<Grid item xs={12} sm={12} md={6} lg={6}>
						<Box className={classes.container}>
							<SupplierShareChart selectedFilters={selectedFilters} />
						</Box>
					</Grid>
					<Grid item xs={12} sm={12} md={6} lg={6}>
						<Box className={classes.container}>
							<AnomalyOverview
								setTabStates={setTabStates}
								handleAnomalyChange={handleAnomalyChange}
								startDate={startDate}
								endDate={endDate}
							/>
						</Box>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<Box className={classes.flexibleContainer}>
							<div>
								<div>
									<Box className={classes.downloadContainer}>
										<TextWithDefinition
											definitionId={'anamoly'}
											hasDefinition={true}
											text={'Anomaly Details and Root Causes'}
											styles={{
												fontSize: '18px',
												color: colors.DARK_GREY,
												fontWeight: 'bold !important',
											}}
										/>
										<IconButton
											size="medium"
											className={classes.button_ellipsis}
											onClick={openMenu}>
											<img alt="Download" src={downloadIcon} />
										</IconButton>
									</Box>

									<Menu
										keepMounted
										anchorEl={anchorEl}
										onClose={closeMenu}
										open={Boolean(anchorEl)}
										anchorOrigin={{
											vertical: 'center',
											horizontal: 'left',
										}}
										transformOrigin={{
											vertical: 'top',
											horizontal: 'right',
										}}>
										<MenuItem
											data-testid="download-excel"
											onClick={handleDownload}>
											<img alt="Download" src={DownloadIcon} />
											<Typography
												sx={{
													fontFamily: `${BOGLE_REGULAR}`,
													marginLeft: '10px',
												}}>
												{DOWNLOAD_EXCEL}
											</Typography>
										</MenuItem>
									</Menu>
									<Box>
										{departmentPositiveItems + departmentNegativeItems > 0 ||
										categoryPositiveItems + categoryNegativeItems > 0 ||
										subcategoryPositiveItems + subcategoryNegativeItems > 0 ? (
											<TabNavigation
												sx={{
													padding: '0 16px',
												}}>
												<TabNavigationItem
													onClick={(event) => {
														handleTabNavigation(event, DEPARTMENT);
													}}
													data-testid={'departmentTab'}
													href=""
													isCurrent={tabStates[0]}
													trailing={
														<Badge color={tabStates[0] ? 'purple' : 'gray'}>
															{(!departmentPositiveItems &&
																!departmentNegativeItems) ||
															!chartData?.details
																? ''
																: departmentPositiveItems +
																  departmentNegativeItems}
														</Badge>
													}>
													{DEPARTMENT}
												</TabNavigationItem>

												<TabNavigationItem
													onClick={(event) => {
														handleTabNavigation(event, CATEGORY);
													}}
													data-testid={'categoryTab'}
													href=""
													isCurrent={tabStates[1]}
													trailing={
														<Badge color={tabStates[1] ? 'purple' : 'gray'}>
															{(!categoryPositiveItems &&
																!categoryNegativeItems) ||
															!chartData?.details
																? ''
																: categoryPositiveItems + categoryNegativeItems}
														</Badge>
													}>
													{CATEGORY}
												</TabNavigationItem>

												<TabNavigationItem
													onClick={(event) => {
														handleTabNavigation(event, SUB_CATEGORY);
													}}
													data-testid={'subCategoryTab'}
													href=""
													isCurrent={tabStates[2]}
													trailing={
														<Badge color={tabStates[2] ? 'purple' : 'gray'}>
															{(!subcategoryPositiveItems &&
																!subcategoryNegativeItems) ||
															!chartData?.details
																? ''
																: subcategoryPositiveItems +
																  subcategoryNegativeItems}
														</Badge>
													}>
													{SUB_CATEGORY}
												</TabNavigationItem>
											</TabNavigation>
										) : (
											<></>
										)}
									</Box>
								</div>
								{!anomaly_summary?.departmentTotal || !chartData?.details ? (
									<ErrorScreen
										isTable={true}
										flag={chartData?.hierarchy_validation || 0}
									/>
								) : (
									<div
										style={{
											display: 'flex',
											gap: '8px',
											flexDirection: 'row',
											margin: '16px 0 16px 16px',
										}}>
										<InlineLabelSelectFormControl data-testid="anomaly-type-form">
											<InlineLabelSelect
												onChange={handleAnomalyChange}
												data-testid="anomaly-type-dropdown"
												value={anomalyType}
												renderValue={() =>
													`Anomaly Type: ${anomalyType?.toLocaleLowerCase()}`
												}
												label="Anomaly Type">
												{anomalyOptions?.map((item) => {
													return (
														<CustomMenuItem
															key={item.id}
															data-testid={item.id}
															value={item.value}>
															<ListItemIcon
																sx={{
																	height: '16px',
																	width: '16px',
																	padding: 0,
																	margin: 0,
																	minWidth: '16px',
																}}>
																<img
																	style={{
																		opacity: anomalyType === item.value ? 1 : 0,
																	}}
																	src={LeadingCheck}
																	alt="checkmark"
																/>
															</ListItemIcon>
															<Typography
																sx={{
																	fontSize: '14px',
																}}>
																{item.label}
															</Typography>
														</CustomMenuItem>
													);
												})}
											</InlineLabelSelect>
										</InlineLabelSelectFormControl>

										<MultiItemDropDown
											ref={rcaDropdownSelect}
											isClearable={false}
											selected={[]}
											placeholder={'Select multi'}
											disabledOptionIndex={-1}
											options={rootCauseOptions}
											label={'Root Cause:'}
											onChange={setRcaValue}
											value={rcaValue}
											onClear={() => setRcaValue([])}
										/>
									</div>
								)}

								{!anomaly_summary?.departmentTotal || !chartData?.details ? (
									''
								) : (
									<DVTable
										columns={tableColumns}
										data={parseData(tableRows)}
										handleCellClicked={handleTableCellClicked}
										filters={externalFilters}
										tableRef={gridRef}
										onGridReady={onGridReady}
										tab={tabStates}
										anomalyType={anomalyType}
										isError={isError}
										initialItemsPerPage={10}
									/>
								)}
							</div>
						</Box>
					</Grid>
				</Grid>
			)}
			<BusinessHierarchy />
		</ThemeProvider>
	);
};

export default PoweredAI;
